import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header.component';
import { ShoppingCartModule } from '../shopping-cart/shopping-cart.module';
import { MobileNavPartsModule } from '../mobile-nav-parts/mobile-nav-parts.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BasicCharactersValidator } from '../../validators';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AutofocusFixModule } from 'ngx-autofocus-fix';
import { SearchModule } from '../search/search.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ShoppingCartModule,
    MobileNavPartsModule,
    HttpClientModule,
    FormsModule,
    LazyLoadImageModule,
    AutofocusFixModule.forRoot(),
    SearchModule
  ],
  declarations: [
    HeaderComponent,
    BasicCharactersValidator
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule { }
